import clsx from "clsx";
import image0 from "../assets/img/cars/image.jpg";

export interface ImageProps {
  image?: string | any;
  size?: "xs" | "sm" | "base" | "lg";
  rounded?: "base" | "lg";
}

export function Image(props: ImageProps) {
  const { image = image0, size = "base", rounded = "base" } = props;

  const sizes = {
    xs: "h-[168px] w-full",
    sm: "h-[168px] sm:h-[228px] w-full",
    base: "sm:w-[332px] w-full h-[247px]",
    lg: "h-[168px] lg:w-full sm:h-[380px]",
  };

  const roundedValues = {
    base: "rounded",
    lg: "rounded-lg",
  };

  return (
    <div
      className={clsx(
        "flex-shrink-0",
        size && sizes[size],
        rounded && roundedValues[rounded]
      )}
    >
      <img
        src={image}
        alt="Automobil"
        className="object-contain w-full h-full"
      />
    </div>
  );
}

export default Image;
